import { configureStore } from "@reduxjs/toolkit";
import proposalReducer from "../features/counter/proposalSlice";

export const store = configureStore({
  reducer: {
    proposal: proposalReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});
